import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { validateZipcode } from '../../redux/slices/ZipCode/zipCodeSlice';

const ZipcodeGate = () => {
  const { t } = useTranslation('common');
  const [zip, setZip] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.zipcode);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!zip.trim()) return;

    try {
      const result = await dispatch(validateZipcode(zip)).unwrap();
      if (result.valid) {
        toast.success(t('zipcode.success'), { duration: 3000 });
        setTimeout(() => navigate('/rooms'), 1500);
      } else {
        toast.error(t('zipcode.error'));
      }
    } catch (err) {
      toast.error(t('zipcode.error'));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-100 to-red-200 px-4">
      <Toaster position="top-center" />
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="text-5xl mb-4">🐕</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('zipcode.title')}</h2>
        <p className="text-gray-500 mb-6">{t('zipcode.subtitle')}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder={t('zipcode.placeholder')}
            value={zip}
            onChange={(e) => setZip(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
            required
          />
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-3 rounded-lg font-semibold text-white transition ${
              isLoading ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            {isLoading ? t('zipcode.checking') : t('zipcode.continue')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ZipcodeGate;